import Config from '@shared/config/constants/config-main';
import axios from 'axios';

export interface CountryDetectionResponse {
  data: {
    isoCode: string;
    name?: string;
  };
  statusCode: number;
  message?: string;
}

export const detectCountry = async (): Promise<CountryDetectionResponse> => {
  const response = await axios.get(`${Config.API_URL}/v1/country/detect`);
  return response.data;
};

export const detectCountryCode = async (): Promise<string> => {
  try {
    const response = await detectCountry();
    return response.data?.isoCode?.toUpperCase() || 'AE';
  } catch (error) {
    console.error('Error detecting country:', error);
    return 'AE';
  }
};
